import React, { useState, useEffect } from 'react';
import {
  UserOnboardingContextProvider,
  readHashFromStorage,
} from '../../contexts/UserOnboardingContext';

const UserProviderWrapper: React.FC<{ children: JSX.Element }> = ({
  children,
}) => {
  const [userHash, setUserHash] = useState<string | undefined>();

  useEffect(() => {
    const userClaimHash = readHashFromStorage();

    if (userClaimHash) {
      setUserHash(userClaimHash);
    }
  }, []);

  return (
    <UserOnboardingContextProvider hash={userHash} type="org">
      {children}
    </UserOnboardingContextProvider>
  );
};

export default UserProviderWrapper;
